var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('p',{staticClass:"mr-2 mb-0"},[_vm._v("Import Attendance")]),_c('input',{ref:"fileInput",attrs:{"type":"file","accept":".dat"}}),_c('v-btn',{attrs:{"small":"","color":"primary","loading":_vm.loading},on:{"click":_vm.uploadFile}},[_vm._v("Upload File")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }